import { inject, Injectable } from '@angular/core';
import { FeatureFlagsService } from '@big-direkt/utils/environment';

@Injectable({
    providedIn: 'root',
})
export class ABTestService {
    private readonly featureFlagsService = inject(FeatureFlagsService);

    public getVariantInfos(limit: number): { limit: number; isVariantBActive: boolean } | undefined {
        const variant = this.featureFlagsService.getVariant('a-b-test-search-limitation')();

        if (!variant) {
            return undefined;
        }

        const isVariantBActive = variant.name === 'Variant_B';

        // we explicitly use || instead of ?? to avoid empty string being cast to 0
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        const limitNew = isVariantBActive ? Number(variant.payload?.value || limit) : limit;

        return {
            limit: limitNew,
            isVariantBActive,
        };
    }
}
